module.exports = __webpack_public_path__ + "img/MercenaryForceGameplay.322191b0.png";